import React, { Component } from 'react';
import _ from 'lodash';
import { Input, Icon } from 'react-materialize';
import { connect } from 'react-redux';
import * as actions from '../../actions';
import './style.css';

class PageSearch extends Component {
  constructor(props) {
    super(props);
    this.handleOnChange = this.handleOnChange.bind(this);
  }

  shouldComponentUpdate(nextProps) {
    return nextProps.searchQuery !== this.props.searchQuery;
  }

  componentDidMount() {
    this.delayedCallback = _.debounce(event => {
      const searchQuery = event.target.value;
      const pagesRaw = this.props.pages;
      this.props.fetchSearchQuery(searchQuery, pagesRaw);
    }, 300);
  }

  handleOnChange(event) {
    event.persist();
    this.delayedCallback(event);
  }

  render() {
    return (
      <Input
        className="searchbar"
        onChange={this.handleOnChange}
        label="Page Search"
        s={12} m={12} l={2}
      >
        <Icon>search</Icon>
      </Input>
    );
  }
}

function mapStateToProps({ searchQuery, pages }) {
  return { searchQuery, pages };
}

export default connect(mapStateToProps, actions)(PageSearch);



// WEBPACK FOOTER //
// ./src/components/Dashboard/PageSearch.js